import React, { useState, useCallback } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow, Libraries } from '@react-google-maps/api';


// Indicador de procesamiento
import CircularProgress from '@mui/material/CircularProgress';

// Tipos de datos
import Ubicacion from '../types/Ubicacion';

interface MapModalProps {
    isOpen: boolean;
    onClose: () => void;
    ubicacion: Ubicacion;
  }

  const MapModal: React.FC<MapModalProps> = ({ isOpen, onClose, ubicacion }) => {

    const librerias: Libraries = ['marker','places'];

    const [infoWindowOpen, setInfoWindowOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDnPoqrEvx7Ume4U61Fe_-eCfcomHcFRwU",
      });
        
      /*const onLoad = useCallback((map: google.maps.Map) => {
        // Puedes realizar accion  es adicionales cuando el mapa se carga si es necesario

        setIsLoading(false);
    }, [ubicacion]);*/


    const mapContainerStyle: React.CSSProperties = {
        width: '100%',
        height: '100%'
    };

    const center: google.maps.LatLngLiteral = {
        lat: ubicacion.latitude,
        lng: ubicacion.longitude
    };

    const elCentro = {
        lat: ubicacion.latitude,
        lng: ubicacion.longitude
    };

    if (!isOpen) return null;

    return (
        <div className="modal">
            <div className="modal-content flex flex-col justify-center items-center w-full h-[85%]">
                <div className="flex flex-row justify-between w-full items-center">
                    <h2>{ubicacion.name} / ubicacion.address</h2>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>
                
                {isLoaded ? (
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={center}
                        zoom={15}
                    >
                        <Marker
                            position={center}
                            visible={true}
                            onClick={() => setInfoWindowOpen(true)}
                            label={{className: 'text-shadow', color: '#0051ba', fontFamily: 'font-arial', fontWeight: 'bold', text: ubicacion.name}}
                            title={ubicacion.name.toUpperCase()}
                            
                            
                        />
                        {infoWindowOpen && (
                            <InfoWindow
                                position={center}
                                onCloseClick={() => setInfoWindowOpen(false)}
                            >
                                <div>
                                    <h3 className="font-bold">{ubicacion.name.toUpperCase()}</h3>                                   
                                    <p>{ubicacion.address}</p>
                                    <p>{ubicacion.additionalInfo}</p>
                                </div>
                            </InfoWindow>
                        )}
                    </GoogleMap>
                ) : (
                    <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h1>Cargando mapa...</h1>
                        <CircularProgress />
                    </div>
                )}
            </div>
        </div>
    );
};

export default MapModal;